import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Modal from './Modal';
import Dropdown from './Dropdown';

class NewContract extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      address: '',
      network: 'main',
      abi: ''
    }
  }

  changeText = (prop) => (evt) => {
    this.setState({ [prop]: evt.target.value });
  }

  onSave = () => {
    const {
      onSave
    } = this.props;
    onSave({ ...this.state, abi: JSON.parse(this.state.abi) });
  }

  render() {
    const {
      onDismiss
    } = this.props;

    const {
      network
    } = this.state;

    return (
      <Modal
        onDismiss={onDismiss}
        large
      >
        <h2>Add new contract</h2>
        <p>
          <input
            type="text"
            className="Input"
            placeholder="Name this contract (up to you)"
            onChange={this.changeText('name')}
          />
        </p>
        <p>
          <input
            type="text"
            className="Input"
            placeholder="Contract Address"
            onChange={this.changeText('address')}
          />
        </p>
        <p>
          <textarea
            className="Textarea"
            placeholder="Contract ABI"
            onChange={this.changeText('abi')}
          ></textarea>
        </p>
        <p>
          <Dropdown
            title="Network"
            placeholder="Select a network"
            options={[
              {text: 'Main Ethereum', value: 'main'},
              {text: 'Rinkeby Test', value: 'rinkeby'}
            ]}
            onChange={this.changeText('network')}
            value={network}
            full
          />
        </p>
        <p>
          <button
            className="Button"
            onClick={this.onSave}
          >Save</button>
        </p>
      </Modal>
    );
  }
}

NewContract.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

export default NewContract;


// WEBPACK FOOTER //
// ./src/components/NewContract.js